import * as Ramda from 'ramda';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { getAccountDetails } from '../api';
import type { AccountDto, ProductType } from '../types';
import { useAPIErrorHandler } from '../components/hooks/useAPIErrorHandler';

interface UseGetAccountDetailsQueryProps {
  accountId: string | undefined;
  productType?: ProductType;
}

export const useGetAccountDetailsQuery = ({
  accountId,
  productType,
}: UseGetAccountDetailsQueryProps) => {
  const handleAPIError = useAPIErrorHandler();

  return useQuery<AccountDto, AxiosError>({
    queryKey: ['account-details', accountId, productType],
    queryFn: () => {
      return getAccountDetails(accountId, {
        params: {
          product: productType,
        },
      }).then(Ramda.prop('data'));
    },
    onError: handleAPIError(
      'Unable to retrieve account details at this time. Please try again later.'
    ),
    enabled: Boolean(accountId),
  });
};
